import { AccessForbiddenPage } from '@openx/components-core/lib/AccessForbiddenBackPage/AccessForbiddenPage';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageHeader } from '@openx/components-header/PageHeader';
import { Feature_Flags_Enum } from '@openx/types/gqlTypes';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';
import { useAuth } from '../../components/AuthContext/context';
import { isMasterOrganisation } from '../../permissions/validators';
import { useFeatureFlag } from '../featureFlags/useFeatureFlag';
import { CuratedDealBuyerDiscountsForm } from './Form/CuratedDealBuyerDiscountsForm';
import { useCuratedDealBuyerDiscountFetch } from './hooks/useCuratedDealBuyerDiscountFetch';

type CuratedDealBuyerDiscountsFormPageParams = {
  curatedDealBuyerDiscountUid: string;
};

export const CuratedDealBuyerDiscountsFormPage = () => {
  const { session } = useAuth();
  const hasCuratedDealBuyerDiscountFeature = useFeatureFlag(Feature_Flags_Enum.CuratedDealBuyerDiscount);
  const { curatedDealBuyerDiscountUid = '' } = useParams<CuratedDealBuyerDiscountsFormPageParams>();
  const { curatedDealBuyerDiscount, demandPartnerName, isError, isLoading, seatById } =
    useCuratedDealBuyerDiscountFetch(curatedDealBuyerDiscountUid);

  const { t } = useTranslation();

  const isEdit = !!curatedDealBuyerDiscountUid;
  const isMasterOrg = isMasterOrganisation(session);
  const title = isEdit ? t('Edit Discount') : t('Create New Discount');

  if (isError) {
    return <Navigate replace to="/error" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (!hasCuratedDealBuyerDiscountFeature || isMasterOrg) {
    return <AccessForbiddenPage />;
  }

  return (
    <PageHeader titlePrefix="OpenXSelect" title={title}>
      <CuratedDealBuyerDiscountsForm
        curatedDealBuyerDiscount={curatedDealBuyerDiscount}
        demandPartnerName={demandPartnerName}
        seatById={seatById}
      />
    </PageHeader>
  );
};
